"use strict";

function QuoteModelFactory(MODULE_INFO, userInputRepository, serviceResponseRepository, quoteOptions, quoteRequestRepository, Util, $rootScope) {
	function create() {
		quoteOptions.setAvailableQuoteResults(serviceResponseRepository.getLastResponseFrom('quickQuote'));

		switch (MODULE_INFO.id) {
			case 'vehicle':
				return new QuoteModel(MODULE_INFO, userInputRepository, serviceResponseRepository, quoteOptions, quoteRequestRepository, Util);
			case 'bike':
				return new BikeQuoteModel(MODULE_INFO, userInputRepository, serviceResponseRepository, quoteOptions, quoteRequestRepository, Util);
			case 'caravan':
				return new CaravanQuoteModel(MODULE_INFO, userInputRepository, serviceResponseRepository, quoteOptions, quoteRequestRepository, Util);
			case 'payments':
				return new PaymentsQuoteModel(MODULE_INFO, userInputRepository, serviceResponseRepository, Util);
			case 'home':
				return new HomeQuoteModel(MODULE_INFO, userInputRepository, serviceResponseRepository, quoteOptions, quoteRequestRepository, Util, $rootScope);
			case 'ctp':
				return new CTPModel(MODULE_INFO, userInputRepository, serviceResponseRepository, Util);
			default:
				throw 'Unknown module info';
		}
	}

	return {
		create: create
	}
}
